/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_0Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move a workbook from Excel`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 Excel 迁移工作簿`)
};

/**
* | output |
* | --- |
* | "Move a workbook from Excel" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_0 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_2_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_0(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_0(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_3_table_rows_2_0 as "gc.search_guides.what_is_gridcraft.sections.3.table.rows.2.0" }